import { getTenantFromToken, removeQueryParams } from "config/helpers/common_helper";
import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";
import { HTTPAidaBaseService, FHIRSearch } from "./http";
import { errorMessageReducer } from "config/helpers/speechTranscriptionHelpers/initialize_speech_helper";
import { constants } from "redux/constants/redux-constants";
import i18n from "multilingual";
import { removeActiveSOAPGeneration } from "redux/actions/activeSOAPGenerationActions";
import { encounterObject } from "redux/actions/EncounterActions";

export const GET_STT_TOKEN = async () => {
  try {
    const token = localStorage.getItem(`jwtToken`);
    if (!token) throw Error("No token found");

    const jwtPayload = jwtDecode(token);
    const tenantId = jwtPayload?.firebase?.tenant;

    const response = await HTTPAidaBaseService.get(
      `/${tenantId}/get-stt-access-token`
    );

    return response.data;
  } catch (error) {
    console.error("Failed to refresh token", error);
  }
};

export const COMPUTE_CDSS = async (conversationId) => {
  try {
    let res = await HTTPAidaBaseService.post(
      `/scribe/internal/tenants/${getTenantFromToken()}/conversations/${conversationId}/cdss/compute`
    );

    return res?.status === 200;
  } catch (error) {
    toast.error(error?.response?.data?.message);
    return false;
  }
};

export const GENERATE_REGENRATE_TEMPLATE = async (
  promptCode,
  encounterId,
  payload = {}
) => {
  let res = await HTTPAidaBaseService.post(
    `/${getTenantFromToken()}/${promptCode}/${encounterId}`,
    payload
  );
  if (res?.data) {
    return res?.data;
  }
};

export const GENERATE_REGENRATE_TEMPLATE_TENANT_SPECIFIC = async (
  promptCode,
  encounterId,
  payload = {}
) => {
  let res = await HTTPAidaBaseService.post(
    `/${getTenantFromToken()}/encounters/${encounterId}/submit/${promptCode}`,
    payload
  );
  if (res?.data) {
    return res?.data;
  }
};

export const START_RECORDING = async (data) => {
  let payload = {
    patientId: data.patientId,
    practitionerId: data.practitionerId,
    organizationId: data.organizationId,
    language: data.language,
    cdss: data?.cdss,
    cdssAfterConversation: data?.cdssAfterConversation,
    ...(data.encounterId && { encounterId: data.encounterId }),
  };

  try {
    let res = await HTTPAidaBaseService.post(
      `/scribe/tenants/${getTenantFromToken()}/conversations/start`,
      payload
    );

    if (res?.data?.id) {
      return res?.data;
    }
  } catch (error) {
    console.log("start recording error", error);
    errorMessageReducer(
      error?.response?.data || error?.response?.data?.response?.data
    );
    return false;
  }
};

export const END_RECORDING = async (payload, dispatch) => {
  dispatch({
    type: constants.RECOGNIZER.SET_END_LOADING,
    payload: true,
  });
  try {
    if(!payload?.conversationId) return
    let res = await HTTPAidaBaseService.post(
      `/scribe/tenants/${getTenantFromToken()}/conversations/${
        payload?.conversationId
      }/end`,
      {
        events: [...payload.recognitionEvents],
        includePrevEncounterSoapNoteInContext: payload.context,
      }
    );
    // COMPUTE_CDSS(payload?.conversationId);
    // return res?.status === 200;
    return res;
  } catch (error) {
    toast.warn(error?.response?.data?.message);
    return false;
  } finally {
    dispatch({
      type: constants.RECOGNIZER.SET_END_LOADING,
      payload: false,
    });
  }
};

export const END_ASYNC_RECORDING = async (payload, dispatch) => {
  dispatch({
    type: constants.RECOGNIZER.SET_END_LOADING,
    payload: true,
  });
  debugger
  try {
    if (!payload?.conversationId) return;
    let res = await HTTPAidaBaseService.post(
      `/scribe/tenants/${getTenantFromToken()}/conversations/${
        payload?.conversationId
      }/end-async`,
      {
        // events: [...payload.recognitionEvents],
        events: payload.recognitionEvents.map(
          ({ PrimaryLanguage, ...rest }) => rest
        ),
        includePrevEncounterSoapNoteInContext: payload.context,
      }
    );
    return res;
  } catch (error) {
    if (
      error.response?.data?.message ===
      "Not enough transcript to generate clinical notes."
    ) {
      removeQueryParams(["tabId", "visitId"]); // removing query params #tabId and #visitId from url if error occurs
      dispatch(encounterObject({})) // removing encounter object from redux store when there is not enough transcript error occurs
    }
    toast.warn(error?.response?.data?.message);
    dispatch(
      removeActiveSOAPGeneration({
        patientId: payload?.patientObj?.id,
        encounterId: payload?.encounterObj?.id,
      })
    );
    return false;
  } finally {
    dispatch({
      type: constants.RECOGNIZER.SET_END_LOADING,
      payload: false,
    });
  }
};

export const END_ASYNC_STATUS = async (payload, dispatch) => {
  try {
    if(!payload?.conversationId) return
    let res = await HTTPAidaBaseService.post(
      `/scribe/tenants/${getTenantFromToken()}/conversations/${
        payload?.conversationId
      }/end-async/status`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const PAUSE_RECORDING = async (payload) => {
  try {
    if(!payload?.conversationId) return
    let res = await HTTPAidaBaseService.post(
      `/scribe/tenants/${getTenantFromToken()}/conversations/${
        payload?.conversationId
      }/pause`,
      // { events: [...payload.recognitionEvents] }
      { events: payload.recognitionEvents.map(({ PrimaryLanguage, ...rest }) => rest) }
    );
    return res?.status === 200;
  } catch (error) {
    // toast.error(i18n.t("Patient_Screen.ERROR_WHILE_PAUSE"));
    return false;
  }
};

export const RECORD_EVENTS = async (payload) => {
  try {
    if(!payload?.conversationId) return
    let res = await HTTPAidaBaseService.post(
      `/scribe/tenants/${getTenantFromToken()}/conversations/${
        payload?.conversationId
      }/record`,
      // { events: [...payload.recognitionEvents] }
      { events: payload.recognitionEvents.map(({ PrimaryLanguage, ...rest }) => rest) }
    );

    if (res?.status === 200) {
      if(res?.data) return res?.data
      else return true
    } else return false;
  } catch (error) {
    // toast.error(error?.response?.data?.message);
    if(error.response?.data?.message === 'conversation duration exceeds the allowed limit'){
      return 'duration_limit_exceeded'
    }
    return false;
  }
};

export const EXECUTE_AI_VOICE_EDIT = async (
  promptCode,
  encounterId,
  payload = {}
) => {
  // try {
  const response = await HTTPAidaBaseService.post(
    `/${getTenantFromToken()}/${promptCode}/${encounterId}`,
    payload
  );

  return response.data;
  // } catch (error) {
  //   toast.error(error?.message);
  //   console.error(error.message);
  //   return false;
  // }
};

export const SOAP_CONTEXT_CHECK = async (patientId) => {
  const response = await FHIRSearch(
    `?resourceType=Observation&subject=${patientId}&code=gen-clinical-notes&_count=0`
  );
  return response.data;
};
